import { Edit } from "react-admin";

import SpecialityGroupForm from "./SpecialityGroupForm";
import BackButtonToolbar from "features/BackButtonToolbar";

const EditSpecialityGroups = () => {
  return (
    <Edit
      mutationMode="pessimistic"
      title="Редактиране на група специалности"
      actions={<BackButtonToolbar />}
    >
      <SpecialityGroupForm />
    </Edit>
  );
};
export default EditSpecialityGroups;
